import React, { useMemo } from 'react'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { emotions_heads, ReasonIcons } from '../../../constants/Constants'
import UserInitialsCircle from './UserInitialsCircle'

export const AlertActivity = ({ activity }) => {
    const { user, type, message, created_date } = activity
    const { t } = useTranslation()

    const label = useMemo(() => {
        if (type === 'actionTaken')
            return (
                <p className="flex-1 text-[#413F5E] text-[14px] leading-5 font-medium">
                    <span className="font-semibold">
                        {user?.first_name} {user?.last_name}
                    </span>{' '}
                    {t('took an action')}
                </p>
            )
        else if (type === 'assignedAction')
            return (
                <p className="flex-1 text-[#413F5E] text-[14px] leading-5 font-medium">
                    <span className="font-semibold">
                        {user?.first_name} {user?.last_name}
                    </span>{' '}
                    {t('assigned')}{' '}
                    <span className="font-semibold">
                        {activity?.assignedTo?.first_name} {activity?.assignedTo?.last_name}
                    </span>{' '}
                    {message ? t('with the following message') : ''}
                </p>
            )
    }, [activity, user, type, message, t])

    return (
        <div className="bg-[#F3EFFF] px-[12px] py-[8px] rounded-[8px] mb-[12px] flex flex-col gap-[6px]">
            <div className="flex flex-row items-center gap-[8px]">
                <UserInitialsCircle user={user} />
                {label}
                <p className="text-[#413F5E] text-[12px] leading-[14px] font-medium">{format(new Date(created_date), 'dd.MM.yyyy HH:mm')}</p>
            </div>
            <div className="text-[#413F5E] text-[14px] leading-5 font-medium pl-[36px]">"{message}"</div>
        </div>
    )
}

export const SingleEmotionDetails = ({ emotion, onlyIcon = false }) => {
    const { t } = useTranslation()
    return (
        <div className="flex flex-row items-center">
            <img src={emotions_heads[emotion.emotion]} width={32} height={32} alt="emotion" />
            <p className="text-darkenPurple text-[14px] leading-5 font-semibold capitalize ml-2">{t(emotion.emotion)}</p>
            <p className="text-darkenPurple text-[12px] leading-[14px] font-medium ml-2 flex-1">{format(new Date(emotion?.created_date), 'dd.MM.yyyy HH:mm')}</p>
            {!!emotion?.reasons?.length && (
                <>
                    <p className="text-darkenPurple text-[14px] leading-5 font-normal ml-2">{t('Reasons')}:</p>
                    <div className="flex flex-row items-center gap-1 ml-3">
                        {emotion?.reasons?.map((reason) => (
                            <div className="flex flex-row items-center gap-[6px] bg-[#ECECF2] rounded-full pl-1 py-1 pr-[10px]" key={reason}>
                                <div className="flex items-center justify-center rounded-full w-6 h-6 bg-[#F8F8FB] ">{ReasonIcons(reason?.toLowerCase(), 16)}</div>
                                {!onlyIcon && <p className="text-[#000000DE] text-[14px] leading-[18px] font-normal capitalize">{t(reason)}</p>}
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}
